import { Injectable } from '@angular/core';
import { MessageTypeEnum } from '@app/ngrx-message/constants/messageTypeEnum';
import { Message } from '@app/ngrx-message/models/client/message';
import { MessageStoreService } from '@app/ngrx-message/services/message/message-store.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AcronymTitleCasePipe } from '@shared/pipes/acronym-title-case.pipe';
import { EASY_PRICING_ACTIONS } from '@usf/ngrx-pricing';
import { selectProductSummaryEntities } from '@usf/ngrx-product';
import { filter, tap, withLatestFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientEasyPricingEffects {
  constructor(
    private actions$: Actions,
    private readonly messageStoreService: MessageStoreService,
    private readonly store: Store,
    private readonly acronymTitleCasePipe: AcronymTitleCasePipe,
    private readonly translateService: TranslateService,
  ) {}

  showUpdateFailureToast$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EASY_PRICING_ACTIONS.updateEasyPricingFail),
        filter(
          action =>
            action.unifiedResponseCode !== 400 &&
            action.unifiedResponseCode !== 401,
        ),
        withLatestFrom(this.store.select(selectProductSummaryEntities)),
        tap(([action, productSummaryEntities]) => {
          const productSummary =
            productSummaryEntities[action.easyPricingUpdate.productNumber];
          const productDescription =
            productSummary?.productDescTxtl ??
            productSummary?.productDescLong ??
            '';

          const message = this.translateService.instant(
            'i18n.lists.pmeList.updateEasyPriceFail',
            {
              kind: action.easyPricingUpdate.isCustomUpdate
                ? 'custom'
                : 'target',
              productDescription:
                this.acronymTitleCasePipe.transform(productDescription),
            },
          );
          this.messageStoreService.upsertMessage({
            type: MessageTypeEnum.error,
            display: message,
            toast: true,
            sticky: true,
          } as Message);
        }),
      ),
    { dispatch: false },
  );
}
